
@if (canSeeHarvestEdit()) {
  <button class="gridbtn" mat-raised-button (click)="editHarvest()" title="Edit Harvest">
    <mat-icon aria-hidden="false" aria-label="Edit Harvest">edit</mat-icon>
  </button>
}
